// ── Collapsible config-file section ─────────────────────────────────────────
//
// Groups a set of drawer fields under the real config file they map to
// (idv_service, con_daon, onesdk_utility, …) so it's obvious where each
// setting actually lives in the platform. Mockup-only; children manage their
// own local state.
import { useState, type ReactNode } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'

export interface ConfigSectionProps {
  title: string
  file: string
  defaultOpen?: boolean
  children: ReactNode
}

export function ConfigSection({ title, file, defaultOpen = false, children }: ConfigSectionProps) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <div className="border border-[#1e2c44] rounded-md overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-2.5 py-2 hover:bg-[#1a2740] transition-colors"
      >
        {open ? (
          <ChevronDown size={13} className="text-[#5b6b85] shrink-0" />
        ) : (
          <ChevronRight size={13} className="text-[#5b6b85] shrink-0" />
        )}
        <span className="text-[11px] font-medium text-[var(--text-primary)]">{title}</span>
        <code className="ml-auto text-[9px] px-1.5 py-0.5 rounded bg-[#0b1220] text-[#818cf8] font-mono shrink-0">
          {file}
        </code>
      </button>
      {open && <div className="px-2.5 pb-3 pt-2 flex flex-col gap-3 border-t border-[#1e2c44]">{children}</div>}
    </div>
  )
}
